<template lang="pug">
  #activity-tracker
    WtButton.make-an-entry(@click.native="openActivityTracker") Add New Entry

    BModal(
      v-show="openActivityTrackingModal"
      :active.sync="openActivityTrackingModal"
      has-modal-card
      :can-cancel="['escape', 'outside']"
      @close="closeActivityTracker"
    )
      .card-contents(:class="{ 'calendar-active': calendarPickerActive }")
        LogTrackingModal(
          @closeActivityTracker="closeActivityTracker"
          @calendarPickerToggle="handleCalendarPickerToggle"
        )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtButton from "@@/WtButton/WtButton";
import LogTrackingModal from "@@/ActivityTracking/LogTrackingModal.vue";
const MakeAnEntryModal = () =>
  import(
    /* webpackChunkName: "MakeAnEntryModal" */ "@@/Members/MakeAnEntry/MakeAnEntryModal"
  ).catch(() => {
    window.location.reload();
  });

export default {
  name: "MakeAnEntry",

  components: {
    LogTrackingModal,
    WtButton
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      openActivityTrackingModal: false,
      calendarPickerActive: false
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),
    ...mapGetters("members", [
      "makeAnEntryJournal",
      "makeAnEntryJournalLoading"
    ])
  },

  mounted() {
    this.unsubscribeActivitiesFetch = this.$store.subscribe(async mutation => {
      if (
        mutation.type === "members/SET_JOURNALS" &&
        !this.activitiesLoaded &&
        !this.activitiesLoading &&
        this.coreProgramMeta.converter
      ) {
        // ensure user is logged-in
        if (this.$auth.user()) {
          this.fetchActivities(this.$auth.user().programId);
        }
      }
    });
  },

  beforeDestroy() {
    this.unsubscribeActivitiesFetch();
  },

  methods: {
    ...mapActions("members", ["fetchActivities"]),

    openModal() {
      const props = {
        isMakeAnEntry: true
      };

      this.$buefy.modal.open({
        parent: this,
        props: props,
        component: MakeAnEntryModal,
        hasModalCard: true
      });
    },

    openActivityTracker() {
      this.openActivityTrackingModal = true;
    },
    closeActivityTracker() {
      this.openActivityTrackingModal = false;
      this.calendarPickerActive = false; // Reset when modal closes
    },
    handleCalendarPickerToggle(isActive) {
      this.calendarPickerActive = isActive;
    }
  }
};
</script>

<style lang="sass" scoped>
.card-contents
  display: flex
  align-items: center
  justify-content: center
  transform: translateY(0px)
  &.calendar-active
    transform: translateY(-120px)
</style>
